import qs from "qs";
import { iHeaders } from "../queries/interfaces/headers";
import cachingStrategies from "../queries/constants/cachingStrategies";

interface iOptions {
	headers?: iHeaders;
	body?: string;
	Cookie?: string;
}

const customFetch = (uri: string, options: iOptions) => {
	// replace uri from env file to host from browser request.
	let src;
	// Works only in browsers and replace http protocol from .env to protocol from browser.
	if (typeof window !== "undefined") {
		uri = uri.replace("http://", `${window.location.protocol}//`);
	}

	if (typeof window !== "undefined") {
		src = window.location?.href.split("/").slice(5, window.location?.href.split("/").length).join("/");
	}

	if (options?.headers?.logIt) {
		console.log("CustomFetch->log", options.body);
	}

	let hash = "";
	if (options.body) {
		const parsed = JSON.parse(options.body);
		hash = parsed?.extensions?.persistedQuery?.sha256Hash || "";
	} else {
		const parsedUrl: any = qs.parse(uri);
		if (parsedUrl?.extensions) {
			const extensions = JSON.parse(parsedUrl.extensions);
			hash = extensions?.persistedQuery?.sha256Hash || "";
		}
		uri = uri.split("?")[0];
	}

	// Check session cookie
	let cookieCode: string | number = 0;
	if (options?.headers?.cachingstrategy) {
		if (options.headers.cachingstrategy === cachingStrategies.role) {
			// todo role caching strategy, get scode from session maybe
		} else if (options.headers.cachingstrategy === cachingStrategies.user) {
			if (options?.headers?.cookie) {
				const cookies = options.headers.cookie.split(";");
				const sessionCookies = cookies.filter(perCookie => perCookie.trim().startsWith("SSESS"));
				if (sessionCookies.length) {
					const sessionCookieSplit = sessionCookies[0].split("=");
					if (sessionCookieSplit.length === 2) {
						cookieCode = sessionCookieSplit[1].trim();
					}
				}
			}
		}
		// we need cachingStrategy only for creating scode, no need send it to gql server
		delete options?.headers?.cachingstrategy;
	}

	delete options.Cookie;

	// !IMPORTANT - never change sha256Hash - apollo wait this name on string
	uri = `${uri}?sha256Hash=${hash}&scode=${cookieCode}&src=${src ? src : "not-found"}`;
	return fetch(uri, options);
};

export default customFetch;
